import React from 'react';
import { RiErrorWarningFill } from 'react-icons/ri';

import { StepProps } from '../../types';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import * as toast from 'legacy/common/utils/toast';
import { useRequestTicketRefundCommand } from '../../../../hooks';

const RequestRefundStep = ({ ticket, onClose, refetchTickets }: StepProps) => {
  const {
    error: refundError,
    mutate: requestRefund,
    isLoading: isRefundLoading
  } = useRequestTicketRefundCommand();

  const onSubmitRefundRequest = () => {
    requestRefund(
      {
        ticketId: ticket.id
      },
      {
        onSuccess: () => {
          refetchTickets();
          onClose();
          toast.success('A refund request has been sent to the host');
        },
        onError: (error) => {
          toast.error(error.message);
        }
      }
    );
  };

  return (
    <>
      <div className="p-4">
        <div className="p-4 mb-7 bg-yellow-100 rounded-lg flex gap-2 align-center">
          <RiErrorWarningFill size={24} />
          <p className="font-bold text-base text-warning-dark">
            Your ticket fees will not be refunded.
          </p>
        </div>
        <div className="font-bold text-small flex gap-2 align-center pb-2">
          <img alt="Ticket icon" src="/img/icons/ticket-admit-one.svg" />
          {ticket.tier.name || ticket.tier.description}
        </div>
      </div>
      {refundError?.message && (
        <div className="mt-4 -mb-4 text-red-500 text-center">
          {refundError?.message}
        </div>
      )}
      <div className="border-t-1 border-solid border-gray-200 p-4">
        <Button
          disabled={isRefundLoading}
          onClick={onSubmitRefundRequest}
          type={ButtonType.Primary}
          loading={isRefundLoading}
        >
          Confirm Request
        </Button>
      </div>
    </>
  );
};

export default RequestRefundStep;
